var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNothing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.943 15.943a1 1 0 0 1 1.414 0l4.35 4.35a1 1 0 1 1-1.414 1.414l-4.35-4.35a1 1 0 0 1 0-1.414M8.172 13.828a1 1 0 0 1 0-1.414l4.242-4.242a1 1 0 1 1 1.414 1.414l-4.242 4.242a1 1 0 0 1-1.414 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.172 8.172a1 1 0 0 1 1.414 0l4.242 4.242a1 1 0 0 1-1.414 1.414L8.172 9.586a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})));
export default SvgNothing;